"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useKPI = exports.default = void 0;

var _react = require("react");

var _material = require("@mui/material");

var _Node = require("./Node");

var _KPITypes = require("./KPITypes");

var _jsxRuntime = require("react/jsx-runtime");

var KPIContext = /*#__PURE__*/(0, _react.createContext)({
  hasDividers: false,
  size: _KPITypes.KPISizes.small
});

var useKPI = function useKPI() {
  return (0, _react.useContext)(KPIContext);
};

exports.useKPI = useKPI;
var StyledRoot = (0, _material.styled)("div")(function () {
  return {
    overflow: "hidden"
  };
});
var StyledContainer = (0, _material.styled)("div", {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "hasDividers";
  }
})(function (_ref) {
  var theme = _ref.theme,
      _ref$hasDividers = _ref.hasDividers,
      hasDividers = _ref$hasDividers === void 0 ? false : _ref$hasDividers;
  return {
    display: "flex",
    flexWrap: "wrap",
    marginLeft: hasDividers ? "-2px" : theme.spacing(0)
  };
});

var KPI = function KPI(_ref2) {
  var children = _ref2.children,
      _ref2$hasDividers = _ref2.hasDividers,
      hasDividers = _ref2$hasDividers === void 0 ? false : _ref2$hasDividers,
      size = _ref2.size;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(KPIContext.Provider, {
    value: {
      hasDividers: hasDividers,
      size: _KPITypes.KPISizes[size]
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledRoot, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledContainer, {
        hasDividers: hasDividers,
        children: children
      })
    })
  });
};

KPI.Node = _Node.Node;
var _default = KPI;
exports.default = _default;